var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c("ManagementPage", {
        attrs: {
          pageName: _vm.$tc("System Settings", 2) + " / " + _vm.$tc("Lists", 2)
        },
        scopedSlots: _vm._u([
          {
            key: "left",
            fn: function() {
              return [
                _c("TableView", {
                  attrs: { selectedItem: _vm.selectedList },
                  on: {
                    "change-tab": function($event) {
                      return _vm.changeTab($event)
                    },
                    "open-create-company-form": function($event) {
                      _vm.selectedList = {}
                    },
                    "clear-selected-item": function($event) {
                      _vm.selectedList = null
                    }
                  }
                })
              ]
            },
            proxy: true
          },
          {
            key: "right",
            fn: function() {
              return [
                _c("Lists", {
                  attrs: { selectedList: _vm.selectedList },
                  on: {
                    "clear-selected-item": function($event) {
                      _vm.selectedList = null
                    }
                  }
                })
              ]
            },
            proxy: true
          }
        ])
      }),
      _vm._v(" "),
      _c("dialog-choice", {
        attrs: {
          isOpen: _vm.discardChangesDialogIsOpen,
          title: _vm.$t("DiscardChanges"),
          content: _vm.$t("ClusterCreationConfirmation"),
          mainActionLabel: _vm.$t("Confirm"),
          secondaryActionLabel: _vm.$t("Cancel"),
          icon: "mdi-delete",
          iconColor: "var(--app-primary-base)"
        },
        on: {
          mainAction: _vm.confirmDiscardChanges,
          secondaryAction: function($event) {
            _vm.discardChangesDialogIsOpen = false
          }
        }
      })
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-e524ebe0", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-e524ebe0","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/views/ListsView.vue
// module id = null
// module chunks = 